<template>
  <div v-show="pageShow">
    <Header/>
    <div class="content-wrapper">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">ติดต่อเรา</h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item active">ติดต่อเรา</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- Content body. -->
      <section class="content">
        <div class="container-fluid">
          <div class="card">
            <div class="card-header d-flex">
              <div class="col-2"></div>
              <div class="col-10 text-right"></div>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table id="dataTable" class="table table-hover table-striped table-bordred">
                  <thead class="thead-light">
                    <tr>
                      <th>No.</th>
                      <th>ชื่อผู้ติดต่อ</th>
                      <th>อีเมล</th>
                      <th>เบอร์โทรศัพท์</th>
                      <th>วันที่บันทึก</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(contact,index) in contacts" :key="contact.index">
                      <td>{{++index}}</td>
                      <td>{{contact.contact_name}}</td>
                      <td>{{contact.contact_email}}</td>
                      <td>{{contact.contact_tel}}</td>
                      <td>{{contact.created_at}}</td>
                      <td>
                        <button
                          class="btn btn-link btn-sm text-success" @click="showMessage(contact)">
                          <i class="fas fa-search"></i> รายละเอียด
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
        <!-- Modal -->
      <div class="modal" id="modalContact">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">ข้อความติดต่อเรา</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <form>
              <div class="modal-body">
                <div class="form-group">
                  <label>ชื่อผู้ติดต่อ</label>
                  <input
                    type="text"
                    placeholder="ป้อนชื่อบทความ"
                    class="form-control"
                    readonly
                    v-model="form.contact_name"
                  >
                </div>
                <div class="form-group">
                  <label>อีเมล</label>
                  <input
                    type="text"
                    placeholder="ป้อนชื่อที่มา"
                    class="form-control"
                    readonly
                    v-model="form.contact_email"
                  >
                </div>
                <div class="form-group">
                  <label>เบอร์โทรศัพท์</label>
                  <input
                    type="text"
                    placeholder="ป้อนลิงค์ที่มา"
                    class="form-control"
                    readonly
                    v-model="form.contact_tel"
                  >
                </div>
                <div class="form-group">
                  <label>ข้อความ</label>
                  <textarea v-model="form.contact_message" class="form-control" cols="30" rows="10" readonly></textarea>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">ปิด</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/HeaderBack";
export default {
  components: {
    Header
  },
  data(){
      return {
          pageShow: false,
          contacts:{},
          form: new Form({
              contact_name:'',
              contact_email:'',
              contact_tel:'',
              contact_message:'',
          })
      }
  },
  beforeCreate() {
    this.axios
      .post(
        "http://pgm01.toonjob.com/2019/BannKlong/project/checkBeforeLogin",
        {
          keyid: this.$session.get("keyid"),
          keyserial: this.$session.get("keyserial"),
          keytoken: this.$session.get("keytoken")
        }
      )
      .then(response => {
        if (response.data.checkLogin === 0) {
          this.pageShow = false;
          window.location.href = "/pageLogin";
        } else {
          this.pageShow = true;
        }
      });
  },
  methods: {
    dataMessage(){
        this.axios.get('http://pgm01.toonjob.com/2019/BannKlong/project/dataMessage')
        .then((response) => {
            this.contacts = response.data
            $(document).ready(function(){
              $('#dataTable').DataTable()
            })
        })
    },
    showMessage(contact){
        this.form.fill(contact)
        $('#modalContact').modal('show')
    }
  },
  created() {
      this.$Progress.start()
      this.dataMessage()
      this.$Progress.finish()
  }
};
</script>


// WEBPACK FOOTER //
// src/backEnd/Contact.vue